import { ReturnsFiltersEnum, ReturnsViews, ReturnsStatuses } from '@/enums/modules/returns'

// Views
export const AllViewFilter = { filterType: ReturnsFiltersEnum.Status, operator: 'eq', value: '', displayValue: ReturnsViews.AllView }
export const AwaitingViewFilter = { filterType: ReturnsFiltersEnum.Status, operator: 'eq', value: ReturnsStatuses.AwaitingArrival, displayValue: ReturnsViews.AwaitingView }
export const ArrivedViewFilter = { filterType: ReturnsFiltersEnum.Status, operator: 'eq', value: ReturnsStatuses.Arrived, displayValue: ReturnsViews.ArrivedView }
export const ProcessingViewFilter = { filterType: ReturnsFiltersEnum.Status, operator: 'eq', value: ReturnsStatuses.Processing, displayValue: ReturnsViews.ProcessingView }
export const CompletedViewFilter = { filterType: ReturnsFiltersEnum.Status, operator: 'eq', value: ReturnsStatuses.Completed, displayValue: ReturnsViews.CompletedView }
export const CancelledViewFilter = { filterType: ReturnsFiltersEnum.Status, operator: 'eq', value: ReturnsStatuses.Cancelled, displayValue: ReturnsViews.CancelledView }

export const FilterViewsMap = {
  [ReturnsViews.AllView]: AllViewFilter,
  [ReturnsViews.AwaitingView]: AwaitingViewFilter,
  [ReturnsViews.ArrivedView]: ArrivedViewFilter,
  [ReturnsViews.ProcessingView]: ProcessingViewFilter,
  [ReturnsViews.CompletedView]: CompletedViewFilter,
  [ReturnsViews.CancelledView]: CancelledViewFilter
}

// Filters
export const SearchFilter = { filterType: ReturnsFiltersEnum.Search, operator: 'eq', value: '', displayValue: '' }
export const FulfillmentCenterFilter = { filterType: ReturnsFiltersEnum.FulfillmentCenter, operator: 'eq', value: '', displayValue: '' }
export const ProductFilter = { filterType: ReturnsFiltersEnum.Product, operator: 'eq', value: '', displayValue: '' }
export const ReferenceIdFilter = { filterType: ReturnsFiltersEnum.ReferenceId, operator: 'eq', value: '', displayValue: '' }
export const ReturnIdFilter = { filterType: ReturnsFiltersEnum.ReturnId, operator: 'eq', value: '', displayValue: '' }
export const OrderIdFilter = { filterType: ReturnsFiltersEnum.OrderId, operator: 'eq', value: '', displayValue: '' }
export const TrackingNumberFilter = { filterType: ReturnsFiltersEnum.TrackingNumber, operator: 'eq', value: '', displayValue: '' }
